import React from 'react';

/**
 * @param {FF.SvgIcon} props
 */
export default function SvgIcon({ children, title, type, ...props }) {
  const svgProps = {
    ...props,
    viewBox:
      props.viewBox ||
      (props.width && props.height
        ? `0 0 ${props.width} ${props.height}`
        : undefined),
    xmlns: 'http://www.w3.org/2000/svg',
  };

  if (type === 'presentation') {
    Object.assign(svgProps, {
      'aria-hidden': 'true',
      focusable: 'false',
      role: 'presentation',
    });
  }

  return (
    <svg {...svgProps}>
      {title && <title>{title}</title>}
      {children}
    </svg>
  );
}
